import { B2BSubnav } from '@zillow/zrs-cms';
import React from 'react';

import OptimizelyScripts from '../../components/OptimizelyScripts';
import GlobalStyle from '../GlobalStyle';
import LayoutHead from '../LayoutHead';
import { TMenuItem } from '../Menu/Menu.types';
import { PreviewModeAlert } from '../PreviewModeAlert';

interface NavComponentProps {
    menu: {
        meta?: {
            title?: string;
            url?: string;
            search?: string;
        };
        items: TMenuItem[];
    };
}

interface LayoutProps {
    head: string;
    menu?: {
        meta?: {
            title?: string;
            url?: string;
            search?: string;
        };
        items: TMenuItem[];
    };
    preview?: boolean;
    children: React.ReactNode;
    NavComponent?: React.ComponentType<NavComponentProps>;
}

const Layout: React.FC<LayoutProps> = ({
    head,
    menu,
    preview,
    children,
    NavComponent = B2BSubnav,
}) => {
    return (
        <React.Fragment>
            <LayoutHead head={head} preview={preview} />
            <OptimizelyScripts />
            <GlobalStyle />
            {menu && <NavComponent menu={menu} />}
            {preview && <PreviewModeAlert />}
            {children}
        </React.Fragment>
    );
};

export default Layout;
